import React from 'react';
import { Eye } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function HookSection() {
  return <section className="cv-section relative w-full overflow-hidden bg-ink-900 py-14 sm:py-20 md:py-28" data-id="element-101" data-mp="7gj8nie1w1g4">
      <div className="pointer-events-none absolute -left-40 top-10 hidden h-[420px] w-[420px] rounded-full bg-crimson/[0.07] blur-3xl sm:block" aria-hidden="true" data-id="element-102" data-mp="m9319p3kqqjb" />
      <div className="relative mx-auto max-w-4xl px-5 sm:px-6" data-id="element-103" data-mp="3pq31k3r8hwwi">
        <SectionHeading label="El Despertar Brutal" icon={Eye} align="left" title={<>
              Digamos las cosas como son: <span className="gold-text" data-id="element-105" data-mp="3umjynngevllq">usted ha sido estafado.</span>
            </>} data-id="element-104" data-mp="3kq764swlrdsk" />

        <div className="mt-7 space-y-5 text-[14.5px] leading-relaxed text-[#b3b8c1] sm:mt-10 sm:space-y-6 sm:text-base" data-id="element-106" data-mp="1dxoaucog5uq5">
          <Reveal delay={0.05} data-id="element-107" data-mp="19w2ps41rea4v">
            <p data-id="element-108" data-mp="19z70zldn6651">
              Ese tratamiento de "optimización celular" que le vendieron como tecnología de la
              NASA... salió de una farmacia de alta gama a{' '}
              <span className="font-semibold text-bone" data-id="element-109" data-mp="3lyhp80rph9ng">15 minutos de su casa</span>. La única
              diferencia es que usted pagó el alquiler de la oficina de mármol del médico y su
              secretaria personal.
            </p>
          </Reveal>

          <Reveal delay={0.1} data-id="element-110" data-mp="2yb02ijnat1rc">
            <blockquote className="relative overflow-hidden rounded-xl border border-white/[0.08] bg-gradient-to-br from-ink-800 to-ink-950 p-5 sm:p-8" data-id="element-111" data-mp="2ybrrvcqay396">
              <span className="absolute left-0 top-0 h-full w-px bg-gradient-to-b from-transparent via-gold-400/70 to-transparent" aria-hidden="true" data-id="element-112" data-mp="37beqjqrncuyj" />
              <p className="text-[14.5px] leading-relaxed text-[#d8d4cc] sm:text-[17px]" data-id="element-113" data-mp="2emr07gs1jfe4">
                Mientras usted cree que está comprando "exclusividad", el sistema se ríe de su falta
                de iniciativa. ¿Va a seguir siendo el cliente preferido de una industria que vive de
                su ignorancia, o va a{' '}
                <span className="font-semibold text-gold-300" data-id="element-114" data-mp="3hwlo3hzqpwyp">tomar el control del suministro</span>?
              </p>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>;
}